import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NavigationButtonState } from './navigation-button.state';

const selectNavigationState = createFeatureSelector<NavigationButtonState>('navigation-button');

export const getNavigationState = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.status,
);

export const getNavigationKind = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.kind,
);

export const getActivePath = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.activePath,
);

export const getVisitedPaths = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.visitedPaths,
);

export const isNavigationLoading = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.status === 'loading',
);

export const isNavigationLoaded = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.status === 'loaded',
);

export const isNavigationPending = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.status === 'pending',
);

export const isNavigationNextStep = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.status === 'next',
);

export const isNavigationActive = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.active,
);

export const isNavigationVisble = createSelector(
    selectNavigationState,
    (navigation: NavigationButtonState) => navigation?.visible,
);
